import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Facebook, Instagram, Star } from "lucide-react";
import { RESTAURANT } from "@/lib/restaurant";
import { getViewReviewsUrl } from "@/components/GoogleReviews";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1F476B] text-[#FDFBF7] mt-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-[#C04E38] grid place-items-center font-serif-display">G</div>
            <div className="font-serif-display text-2xl">Globo Dancing</div>
          </div>
          <p className="text-sm text-white/75 leading-relaxed">
            Cuisine portugaise authentique, plats du jour savoureux, et fêtes en
            famille tous les week-ends. Au cœur de Trappes.
          </p>
        </div>

        <div>
          <h4 className="font-serif-display text-lg mb-4 text-white">Visiter</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/menu" className="hover:text-[#C04E38] transition">La carte</Link></li>
            <li><Link to="/evenements" className="hover:text-[#C04E38] transition">Soirées</Link></li>
            <li><Link to="/galerie" className="hover:text-[#C04E38] transition">Galerie</Link></li>
            <li><Link to="/privatisation" className="hover:text-[#C04E38] transition">Privatisation</Link></li>
            <li><Link to="/reserver" className="hover:text-[#C04E38] transition">Réserver</Link></li>
            <li><Link to="/contact" className="hover:text-[#C04E38] transition">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif-display text-lg mb-4 text-white">Nous trouver</h4>
          <ul className="space-y-3 text-sm text-white/85">
            <li className="flex gap-3"><MapPin size={16} className="mt-0.5 text-[#C04E38]" /> {RESTAURANT.fullAddress}</li>
            <li className="flex gap-3"><Phone size={16} className="mt-0.5 text-[#C04E38]" /> <a href={`tel:${RESTAURANT.phone.replace(/\s/g,'')}`} className="hover:text-[#C04E38]">{RESTAURANT.phone}</a></li>
            <li className="flex gap-3"><Mail size={16} className="mt-0.5 text-[#C04E38]" /> <a href={`mailto:${RESTAURANT.email}`} className="hover:text-[#C04E38] break-all">{RESTAURANT.email}</a></li>
          </ul>
          <a href={RESTAURANT.googleMapsUrl} target="_blank" rel="noopener noreferrer"
             className="inline-flex items-center gap-2 mt-4 text-sm bg-[#C04E38] hover:bg-[#A63D2A] text-white rounded-full px-4 py-2 transition"
             data-testid="footer-gmaps-link">
            <MapPin size={14}/> Voir sur Google Maps
          </a>
        </div>

        <div>
          <h4 className="font-serif-display text-lg mb-4 text-white">Horaires</h4>
          <ul className="space-y-2 text-sm text-white/85">
            {RESTAURANT.hours.map((h, i) => (
              <li key={i} className="flex gap-3"><Clock size={16} className="mt-0.5 text-[#C04E38] shrink-0" /> <span>{h.d} : {h.h}</span></li>
            ))}
          </ul>
          <div className="flex gap-3 mt-5 flex-wrap">
            {RESTAURANT.social.facebook && <a href={RESTAURANT.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#C04E38] grid place-items-center transition"><Facebook size={16} /></a>}
            <a href={RESTAURANT.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#C04E38] grid place-items-center transition" data-testid="footer-instagram"><Instagram size={16} /></a>
            <a href={getViewReviewsUrl()} target="_blank" rel="noopener noreferrer" aria-label="Avis Google" className="inline-flex items-center gap-2 px-3 h-9 rounded-full bg-white/10 hover:bg-[#C04E38] text-xs transition" data-testid="footer-google-reviews">
              <Star size={14} fill="#FFB300" className="text-[#FFB300]"/> {RESTAURANT.google.rating.toFixed(1)} sur Google
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-5 text-center text-xs text-white/60">
        © {new Date().getFullYear()} {RESTAURANT.legalName} · SIRET {RESTAURANT.legal.siret} · Tous droits réservés
        <div className="mt-2 flex flex-wrap justify-center gap-x-4 gap-y-1">
          <Link to="/mentions-legales" className="hover:text-[#C04E38]" data-testid="footer-legal-link">Mentions légales</Link>
          <Link to="/confidentialite" className="hover:text-[#C04E38]" data-testid="footer-privacy-link">Confidentialité</Link>
          <Link to="/admin" className="hover:text-[#C04E38]" data-testid="footer-admin-link">Espace admin</Link>
        </div>
      </div>
    </footer>
  );
}
